export default __webpack_public_path__ + "static/media/profile.18e9d83c.svg";